<template>
  <div id="exchangeLog-index">
    <header><img src="@/assets/img/logo.png" alt=""></header>

    <!-- remind-modal -->
    <div class="remind-popup" v-if="isRemindPopup">
      <div class="remind-popup-wrapper">
        <div class="remind-content">
          <h2>{{ remindTitle }}</h2>
          <p>{{ remindText }} <span v-show="!isBind">【<a href="javascript:void(0);" @click="closeRemind()">會員綁定</a>】</span></p>
          <div class="remind-button">
            <button class="close_button" @click="isRemindPopup = false"><img src="@/assets/img/modal_close.png"
                alt=""></button>
            <button class="confirm_button" @click="closeRemind()"><img src="@/assets/img/remind_button.png"
                alt=""></button>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="wrapper">
        <div class="nav-area">
          <div class="nav-return" @click="toUrl('points')">
            <img src="@/assets/img/return_page.png" alt="">
          </div>
          <div class="nav-title">
            <img src="@/assets/img/exchange_title.png" alt="">
          </div>
        </div>
        <div class="log"> 
          <p class="log-border"></p>
          <div class="loading" id="waitingPageLoading" v-show="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="color-f" v-if="records.length === 0">暫無資料</div>
          <div class="log-area" v-for="record in records" :key="record.seq" v-else>
            <div class="log-info">
              <div class="log-text">
                <p class="color-f">{{ record.title }}</p>
                <p class="color-y">兌點日期：{{ record.created_at.split(':')[0] + ':' + record.created_at.split(':')[1] }}
                </p>
                <p class="color-y text-left">兌換組數：{{ record.unit }}組</p>
              </div>
              <div class="log-point">
                <p>扣點<span>{{ record.total }}點</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/utils/Api';

export default {
  name: 'exchangeLog',
  data() {
    return {
      records: {},
      loading: true,
      isRemindPopup: false,
      isBind: true,
    }
  },
  mounted() {
    document.body.style.background = '#060606'
    this.initial();
  },
  computed: {

  },
  methods: {
    async initial() {
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);
      try {
        let { data: { data } } = await api.getRecords();
        this.records = data;
      } catch (error) {
        let errorMessage = "未知錯誤";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.remindTitle = '錯誤訊息';


        if (errorMessage === '請先進行綁定') {
        this.remindText = '您尚未綁定會員 無法兌換點數 請您先進行';
        this.isRemindPopup = true;
        this.isBind = false;
      } else {
        this.remindText = errorMessage;
        this.isRemindPopup = true;
      }

      } finally {
        this.loading = false;
      }
    },
    closeRemind() {
      if (this.remindText === '您尚未綁定會員 無法兌換點數 請您先進行') {
        sessionStorage.setItem('goBackUrl', location.href);
        location.href = `${location.origin}/web/member/bind/index.html`;
      } else {
        this.isRemindPopup = false;
      }
    },
    toUrl(val, params = {}) {
      this.$router.push({ path: `/${val}`, params: `/${params}` });
    },
  },
};
</script>

<style scoped>
.container {
  font-family: 'Roboto', sans-serif;
}

p {
  margin: 0;
}

button {
  background: none;
  border: none;
}

button:focus {
  outline: none;
}

.color-f {
  color: #fff;
}

.color-y {
  color: #fdf2c9;
}

.text-left {
  text-align: left;
}

.status-color {
  color: var(--bronze);
}

header {
  position: relative;
}

/* nav */
.nav-area {
  display: flex;
  padding: 10px 0 10px 0;
  align-items: stretch;
  position: relative;
}

.nav-area .nav-return {
  position: absolute;
  left: 6.5%;
  width: 8.5%;
}

.nav-area .nav-title {
  width: 42%;
  margin: auto;
  margin-top: 3px;
}

/* log */
.log {
  padding: 0px 25px;
}

.log .log-border {
  border-bottom: 2px solid #fdf2c9;
  margin: 10px 0 20px 0;
}

.log .log-area {
  border: 1px solid #fdf2c9;
  border-radius: 15px;
  background: #4d4d4d;
  padding: 25px 0px;
  padding-right: 25px;
  margin-bottom: 20px;
}

.log-area .log-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.log-area .log-info .log-text {
  margin: auto;
}

.log-area .log-info .log-text .color-f {
  font-weight: bold;
  font-size: 18px;
}

.log-area .log-info .log-point {
  position: relative;
}

.log-area .log-info .log-point p {
  font-weight: bold;
  color: #fff;
}

.log-area .log-info .log-point span {
  font-weight: bold;
  color: #f0cb46;
}

.log-area .log-info .log-point::before {
  content: '';
  border-left: 1px solid #fdf2c9;
  position: absolute;
  height: 75px;
  right: 0;
  left: -12px;
  bottom: 0;
  top: -24px;
}

/* remind-modal */

.remind-popup {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  overflow-x: hidden;
}

.remind-popup-wrapper {
  position: absolute;
  background: #fff;
  padding: 15px 25px 30px 25px;
  width: 95%;
  max-width: 400px;
  max-height: 88%;
  -webkit-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.remind-content h2 {
  font-size: 20px;
  font-weight: bold;
  color: #c0272b;
  margin: 25px 0;
}

.remind-content p {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.remind-content span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.remind-content a {
  color: #007aff;
  text-decoration: underline !important;
}

.remind-button {
  display: flex;
  justify-content: space-between;
}

.remind-button img {
  display: block;
  margin: auto;
  width: 90%;
  padding: 20px 0 20px 0;
}

@media (max-width: 400px) {
  .log-area .log-info .log-text .color-f {
    font-weight: bold;
    font-size: 16px;
  }

  .log .log-area p,
  .log .log-area span {
    font-size: 14px;
  }

  .log-area .log-info .log-point::before {
    left: -8px;
  }
}

@media (max-width: 349px) {
  .log-area .log-info .log-text .color-f {
    font-weight: bold;
    font-size: 14px;
  }

  .log .log-area p,
  .log .log-area span {
    font-size: 12px;
  }

  .log-area .log-info .log-point::before {
    left: -8px;
  }
}
</style>